import React from "react";
import { Reveal } from "@/lib/motion";

export const SectionHead = ({ eyebrow, title, sub, center = true, light = false, className = "" }) => (
  <Reveal className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-12 sm:mb-16 ${className}`}>
    {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
    <h2 className={`font-serif text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.15] tracking-tight ${light ? "text-cream" : "text-forest"}`}>{title}</h2>
    {sub && <p className={`mt-4 text-sm sm:text-base leading-relaxed ${light ? "text-cream/70" : "text-mutedgreen"}`}>{sub}</p>}
  </Reveal>
);
